export default __webpack_public_path__ + "static/media/user_medical_professional.ad2e2be0.svg";